(function init() {
  angular.module('app').controller('host.views.debugTools.addHubCaseReference.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.confirm = confirm;

      vm.caseId = '';
      vm.referenceId = '';

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        vm.saving += 1;

        const input = {
          caseId: vm.caseId,
          referenceId: vm.referenceId,
        };

        debugToolSvc
          .addHubCaseReference(input)
          .success(() => {
            abp.notify.info('Added inputted fields to Hub Case Reference');
          })
          .finally(() => {
            vm.saving -= 1;
            vm.caseId = '';
            vm.referenceId = '';
          });
      }
    },
  ]);
})();
